import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-white flex flex-col justify-between p-3 w-full" }
const _hoisted_2 = { class: "flex-shrink font-bold text-sm" }
const _hoisted_3 = { class: "flex items-end justify-between text-center" }
const _hoisted_4 = { class: "mt-2 xs:mt-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NextButton = _resolveComponent("NextButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.titolo), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: _normalizeClass(["font-bold", _ctx.coloreStatoClass])
      }, _toDisplayString(_ctx.numero), 3),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_NextButton, {
          variant: "outline-secondary",
          component: "router-link",
          to: _ctx.vediLink,
          class: "block px-3 py-1 text-xs"
        }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createTextVNode("Vedi")
          ])),
          _: 1
        }, 8, ["to"])
      ])
    ])
  ]))
}